var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast"}},[(_vm.current)?_c('div',{staticClass:"toast",class:_vm.current.type,attrs:{"role":"status"}},[_vm._v(_vm._s(_vm.current.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }